module.exports = __webpack_public_path__ + "static/media/icon-locked.7092a216.svg";